import React from 'react'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconLabelButtonRoot } from '../../form/l1/L1Button'
import { LibraryIconProp } from '@fusion-advantage/formlib'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface AppHeaderNavTabRootProps {
	active: boolean
}

const AppHeaderNavTabRoot = styled(IconLabelButtonRoot)<AppHeaderNavTabRootProps>(({theme, active}) => ({
	backgroundColor: active ? theme.colors.miniHeader : theme.colors.transparent,
	color: active ? theme.colors.white : 'inherit',
	fontSize: '1rem',
	...(active ? theme.fonts.titleBold : theme.fonts.title),
	borderTopLeftRadius: theme.borderRadius,
	borderTopRightRadius: theme.borderRadius,
	padding: '0.75rem 1.75rem',
	columnGap: '0.5rem',
}))

interface L1AppHeaderNavTabProps {
	label: string
	icon: IconProp|LibraryIconProp
	active: boolean
	onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const V2L1AppHeaderNavTab = ({label, icon, active, onClick}: L1AppHeaderNavTabProps) => {
	return (
		<AppHeaderNavTabRoot active={active} onClick={onClick}>
			<FontAwesomeIcon icon={icon as IconProp} />
			<div>{label}</div>
		</AppHeaderNavTabRoot>
	)
}
